import {
  DELETE_LOGO_SUCCESS,
  GET_BUILDINGS_LIST_SUCCESS,
  TOGGLE_LOGO_DISABLED_SUCCESS,
} from '../actionConstants';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_BUILDINGS_LIST_SUCCESS:
      return action.res.data;
    case DELETE_LOGO_SUCCESS:
    case TOGGLE_LOGO_DISABLED_SUCCESS: {
      const {
        buildingId,
        disabledLogo,
        isLightLogo,
        isDarkLogo,
        disabledLightLogo,
        disabledDarkLogo,
      } = action;
      if (!buildingId) return state;
      const buildings = [...state];

      const updatedBuildingIndex = buildings
        ?.map(({ id }) => id)
        ?.indexOf(+buildingId);
      if (updatedBuildingIndex < 0) return state;
      const updatedBuilding = buildings?.find(({ id }) => id === +buildingId);
      if (disabledLogo !== undefined) {
        updatedBuilding.disabledLogo = disabledLogo;
      }
      if (disabledLightLogo !== undefined) {
        updatedBuilding.disabledLightLogo = disabledLightLogo;
      }
      if (disabledDarkLogo !== undefined) {
        updatedBuilding.disabledDarkLogo = disabledDarkLogo;
      }
      if (isLightLogo) {
        updatedBuilding.logo = null;
      }
      if (isDarkLogo) {
        updatedBuilding.darkLogo = null;
      }
      buildings.splice(updatedBuildingIndex, 1, updatedBuilding);
      return buildings;
    }
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    default:
      return state;
  }
};
